import { TicketStatus } from '@/constants/ticket-status'
import type { Ticket } from '@/interfaces/ticket'

export function isHumanInProgressTicket(ticket?: Ticket | null) {
  if (!ticket) return false

  return (
    ticket.status === TicketStatus.IN_PROGRESS &&
    ticket.routingType === 'HUMAN' &&
    Boolean(ticket.attendantId)
  )
}

export function isAgentInProgressTicket(ticket?: Ticket | null) {
  if (!ticket) return false

  return (
    ticket.status === TicketStatus.IN_PROGRESS && ticket.routingType === 'AGENT'
  )
}

export function canTakeOverTicket(ticket?: Ticket | null) {
  if (!ticket) return false

  return (
    ticket.status === TicketStatus.PENDING || isAgentInProgressTicket(ticket)
  )
}

export function getCurrentChatTicket(
  ticketId: number | null,
  ...ticketGroups: Ticket[][]
) {
  if (!ticketId) return null

  return ticketGroups.flat().find((ticket) => ticket.id === ticketId) ?? null
}
